import { cloneDeep } from 'lodash';

// Services.
import parseFiltersFromUrl from './parse-filters-from-url';

/**
 * Given a filters object, an operation, a filter to affect, and a value,
 * returns a modified filters object that reflects the requested changes.
 * @param {object} filters - Filters object to modify.
 * @param {string} operation - Operation to perform. One of 'set', 'reset', 'add', 'remove'.
 * @param {string} filter - The filter to modify.
 * @param {*} value - The value to apply. Null is used in conjunction with reset.
 * @returns {object} The new filters object with the requested modification applied.
 */
const modifyFilters = (filters, operation, filter, value = null) => {
  const next = cloneDeep(filters);
  if (operation === 'reset') {
    const defaultValues = parseFiltersFromUrl('');
    next[filter] = defaultValues[filter];
  } else if (value !== null) {
    if (operation === 'set') {
      next[filter] = value;
    } else if (operation === 'add' || (operation === 'toggle' && !filters[filter].includes(value))) {
      next[filter].push(value);
    } else if (operation === 'remove' || (operation === 'toggle' && filters[filter].includes(value))) {
      next[filter] = next[filter].filter((check) => check !== value);
    }
  }

  return next;
};

export default modifyFilters;
